export default __webpack_public_path__ + "static/media/activeM1.f974d84d.svg";